var _path, _path2, _path3, _path4, _path5;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMusico = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.00001C16 7.35448 15.9255 6.7274 15.7855 6.12518L14.6805 6.73983C14.7549 7.14746 14.7937 7.56764 14.7937 8.00001C14.7937 11.7281 11.8808 14.7491 8.28589 14.7491V16C12.545 16 16 12.4201 16 8.00001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1563 7.98461C14.1563 7.63249 14.1265 7.28959 14.0699 6.95593L13.0133 7.25329C13.046 7.49427 13.064 7.73833 13.064 7.98842C13.064 10.79 10.6933 13.0933 8.28296 13.0933V13.9953C11.5264 13.9953 14.1563 11.305 14.1563 7.98461Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4 5.51997L13.3611 4.96366C12.3425 3.17523 10.4512 1.97375 8.28296 1.97375V3.01326C9.7333 3.01326 11.68 4.10668 12.4 5.51997Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3626 2.04788L11.9583 0.966769C10.8652 0.349046 9.61426 0 8.28589 0V1.24788C9.39986 1.24788 10.4453 1.53822 11.3626 2.04788Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71409 16V13.0903C5.33329 13.0903 2.93329 10.8108 2.93329 8C2.93329 5.18917 5.41329 3.01329 7.70671 3.01329V0C3.44751 0 0 3.57994 0 8C0 12.4201 3.45194 16 7.71409 16Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMusico, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Musico.5905acba.svg";
export { ForwardRef as ReactComponent };